import type * as React from 'react';

import type { BlockProps } from '@gitbook/slate-react';

import { CodeBlockLine } from '../../CodeBlocks';

/*
 * Basic renderer for a code block line.
 */
export function BasicBlockCodeLine(props: BlockProps): React.ReactElement {
    const { node, parent, children } = props;

    return <CodeBlockLine number={parent.getChildIndex(node.key) + 1}>{children}</CodeBlockLine>;
}
